import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Container, Typography, SvgIcon } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // 特定のchunk読み込み失敗エラーだけに反応
    const isChunkLoadFailed =
      error?.message && error.message.includes('Loading chunk');

    if (isChunkLoadFailed) {
      return { hasError: true };
    }

    return null;
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // フックが使えないので useMediaQuery を関数として分離
      const mdUp = window.matchMedia('(max-width:960px)').matches;

      return (
        <Box
          component="main"
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexGrow: 1,
            py: '80px'
          }}
        >
          <Container maxWidth="lg">
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mb: 6
              }}
            >
              <SvgIcon
                component={ErrorOutlineIcon}
                sx={{
                  fontSize: 100,
                  color: 'text.secondary'
                }}
              />
            </Box>
            <Typography align="center" variant={mdUp ? 'h1' : 'h4'}>
              <FormattedMessage
                defaultMessage="アプリケーションの読み込みに失敗しました。"
                id="ChunkError.Typography.Message.0"
              />
            </Typography>
            <Typography align="center" color="text.secondary" sx={{ mt: 0.5 }}>
              <FormattedMessage
                defaultMessage="ページを再読み込みしてください。"
                id="ChunkError.Typography.Message.1"
              />
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 6
              }}
            >
              <Button onClick={this.handleReload}>
                <FormattedMessage
                  defaultMessage="ページを再読み込み"
                  id="ChunkError.Button.Reload"
                />
              </Button>
            </Box>
          </Container>
        </Box>
      );
    }

    return this.props.children;
  }
}

ChunkErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

export default ChunkErrorBoundary;
